import { useCallback } from "react";
import type { FieldValues, useForm } from "react-hook-form";
import { useWatch } from "react-hook-form";
import { useDebouncedEffect } from "./use-debounced-effect";

export function useAutoSave<T extends FieldValues>(
	context: ReturnType<typeof useForm<T>>,
	onSubmit: (data: T) => void,
	timeout = 500,
) {
	const watch = useWatch({ control: context.control });
	const { dirtyFields } = context.formState;
	const hasDirtyFields = Object.keys(dirtyFields).length > 0;

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const debouncedSave = useCallback(() => {
		context.handleSubmit(onSubmit)();
	}, [context, onSubmit]);

	useDebouncedEffect(
		() => {
			if (hasDirtyFields) {
				debouncedSave();
			}
		},
		[watch, hasDirtyFields],
		timeout,
	);
}
